var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, flow, when, makeObservable } from 'mobx';
export class AnswerAttributes {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get answer() {
        return this.parent;
    }
    get app() {
        return this.answer.app;
    }
    get availableQuestion() {
        return this.answer.availableQuestion;
    }
    points_stored;
    get points() {
        if (typeof this.points_stored !== 'undefined') {
            return this.points_stored;
        }
        return (this.availableQuestion && this.availableQuestion.answeringInfo.reachedPoints) || 0;
    }
    set points(p) {
        this.points_stored = p;
    }
    maxpoints_stored;
    get maxPoints() {
        return (this.availableQuestion && this.availableQuestion.maxPoints) || this.maxpoints_stored || 1;
    }
    set maxPoints(p) {
        this.maxpoints_stored = p;
    }
    avg_stored;
    get avg() {
        return (this.availableQuestion && this.availableQuestion.questionInfo.average) || this.avg_stored || 0.66;
    }
    set avg(p) {
        this.avg_stored = p;
    }
    evaltext_stored = '';
    get evaltext() {
        if (this.evaltext_stored.length > 0)
            return this.evaltext_stored;
        return (this.availableQuestion && this.availableQuestion.questionScore.legacyEvalText) || '';
    }
    set evaltext(t) {
        if (!t)
            return;
        this.evaltext_stored = t;
        if (this.availableQuestion) {
            this.availableQuestion.questionScore.legacyEvalText = t;
        }
        else {
            this.setEvalTextAsync(t);
        }
    }
    setEvalTextAsync = flow(function* (t) {
        yield when(() => this.answer.fetchedQuestion);
        const question = this.answer.solidQuestion;
        if (!question) {
            console.warn('question should be there!');
            return;
        }
        question.questionScore.legacyEvalText = t;
    });
}
__decorate([
    computed
], AnswerAttributes.prototype, "avg", null);
__decorate([
    computed
], AnswerAttributes.prototype, "evaltext", null);
